import React, { useState } from "react";
import s from "./MobileHeader.module.scss";
import { Drawer } from "antd";
import { Link, useLocation } from "react-router-dom";
import {
  HomeOutlined,
  ApartmentOutlined,
  TeamOutlined,
  AuditOutlined,
  LinkOutlined,
  BookOutlined,
  LoginOutlined,
  CloseOutlined,
  GlobalOutlined,
} from "@ant-design/icons";
import { getNews } from "../../../../redux/LangingPageSlice";
import { useDispatch } from "react-redux";

const links = [
  { to: "/", label: "Home", icon: <HomeOutlined /> },
  { to: "/history", label: "History", icon: <ApartmentOutlined /> },
  { to: "/aboutMctac", label: "What is MCTAC", icon: <TeamOutlined /> },
  { to: "/committee", label: "Advisory Committee", icon: <AuditOutlined /> },
  { to: "/aboutHub", label: "About Digital Transit Hub", icon: <BookOutlined /> },
  {
    to: "/regionalRepresentatives",
    label: "Regional Representatives",
    icon: <GlobalOutlined />,
  },
  { to: "/news", label: "News & Events", icon: <LinkOutlined />, news: true },
];

const MobileHeader = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const isActive = (path) =>
    path === "/"
      ? pathname === "/" || pathname === "/home"
      : pathname.startsWith(path);

  return (
    <header
      className={
        isActive("/") ? `${s.mobileHeader} ${s.on_dark}` : s.mobileHeader
      }
    >
      <Link to="/" className={s.brand}>
        <img src="/Logo MCTAC.png" className={s.logo} alt="MCTAC" />
        <span className={s.brand_name}>MCTAC</span>
      </Link>
      <button
        type="button"
        className={s.burger}
        onClick={() => setIsOpen(true)}
        aria-label="Open menu"
      >
        <span></span>
        <span></span>
      </button>

      <Drawer
        open={isOpen}
        onClose={() => setIsOpen(false)}
        placement="right"
        width={300}
        closable={false}
        rootClassName={s.drawer}
      >
        <div className={s.drawer_head}>
          <span className={s.brand_name}>MCTAC</span>
          <button
            type="button"
            className={s.close}
            onClick={() => setIsOpen(false)}
            aria-label="Close menu"
          >
            <CloseOutlined />
          </button>
        </div>
        <nav className={s.nav}>
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={
                isActive(l.to) ? `${s.nav_item} ${s.active}` : s.nav_item
              }
              onClick={() => {
                setIsOpen(false);
                if (l.news) dispatch(getNews());
              }}
            >
              <span className={s.icon}>{l.icon}</span>
              {l.label}
            </Link>
          ))}
        </nav>
        <Link to="/signIn" className={s.cta} onClick={() => setIsOpen(false)}>
          <LoginOutlined /> Digital Transit HUB
        </Link>
      </Drawer>
    </header>
  );
};

export default MobileHeader;
